/**
 * Canonical HTTP Request Header Constants
 *
 * Single source of truth for all request/response header names used across
 * the API, web client, and generated contracts. Both client and API must
 * import from here to ensure header name consistency.
 */
/** Standard headers */
export const AUTHORIZATION = 'Authorization';
export const CONTENT_TYPE = 'Content-Type';
export const ACCEPT_LANGUAGE = 'Accept-Language';
/** Correlation & tracing headers */
export const X_REQUEST_ID = 'X-Request-ID';
export const X_CORRELATION_ID = 'X-Correlation-ID';
/** Security headers */
export const X_CSRF_TOKEN = 'X-CSRF-Token';
/** Idempotency header */
export const IDEMPOTENCY_KEY = 'Idempotency-Key';
/** All canonical request headers that clients may send */
export const CANONICAL_REQUEST_HEADERS = [
    AUTHORIZATION,
    CONTENT_TYPE,
    ACCEPT_LANGUAGE,
    X_REQUEST_ID,
    X_CORRELATION_ID,
    X_CSRF_TOKEN,
    IDEMPOTENCY_KEY,
];
/** Headers allowed in credentialed CORS preflight responses */
export const CORS_ALLOWED_HEADERS = [
    AUTHORIZATION,
    CONTENT_TYPE,
    ACCEPT_LANGUAGE,
    X_REQUEST_ID,
    X_CORRELATION_ID,
    X_CSRF_TOKEN,
    IDEMPOTENCY_KEY,
];
/** Headers exposed to the browser in credentialed responses */
export const CORS_EXPOSED_HEADERS = [
    X_REQUEST_ID,
    X_CORRELATION_ID,
];
/** HTTP methods that are not idempotent and require idempotency keys for safe replay */
export const NON_IDEMPOTENT_METHODS = ['POST', 'PUT', 'PATCH', 'DELETE'];
